import 'owl.carousel';
import mixitup from 'mixitup';
import Swiper from 'swiper/swiper-bundle.min';
var Sticky = require('sticky-js');

$('.slider-history').owlCarousel({
    loop: true,
    nav: false,
    dots: true,
    margin: 10,
    items: 1,
    smartSpeed: 1000,
    dotsSpeed: 1000,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
});

$('.slider-column').owlCarousel({
    loop: true,
    nav: false,
    dots: true,
    margin: 10,
    items: 1,
    autoHeight: true,
    smartSpeed: 1000,
    dotsSpeed: 1000,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
});
var slider_top = new Swiper(".slider-top", {
    slidesPerView: 10,
    spaceBetween: 7,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        0: {
            slidesPerView: 2
        },
        768: {
          slidesPerView: 6
        },
        1200: {
          slidesPerView: 10
        }
    }
});

if($(window).width() > 980) {
    var sticky = new Sticky('.parent-slider-history');
    var sticky2 = new Sticky('.image-float');
}

$(function() {
    $('.page-general__column-time').each(function(index, element) {
        //let datetime = new Date('Oct 30, 2022 22:38:00').getTime();
        let datetime = new Date($(element).data('date')).getTime();
        if (typeof datetime == 'undefined' || datetime == '') return true;

        const second = 1000,

        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

        let countDown = new Date(datetime).getTime(),
            x = setInterval(function() {

            let now = new Date().getTime(),
                distance = countDown - now;

            document.getElementById('dias').innerText = Math.floor(distance / (day))+'',
            document.getElementById('horas').innerText = Math.floor((distance % (day)) / (hour))+'',
            document.getElementById('minutos').innerText = Math.floor((distance % (hour)) / (minute))
            //document.getElementById('segundos').innerText = Math.floor((distance % (minute)) / second);
        }, second);
    });
})



/*if ( $('.slider-f').length ) {
    var mixer = mixitup('.slider-f');
}*/

$(".mixitup-filter").each(function(index, element) {
    console.log('element', element);

    /*if (typeof $(element).data('filter')  === 'undefined') return true;
    if (typeof $(element).data('mixitupFilter')  === 'undefined') return true;*/
    mixitup(element, {
        controls: {
            scope: 'local'
        }
    });
});

$('.mixitup-filter .filter').on('click', function() {
    if ( $(this).hasClass('mixitup-control-active') ) {
        setTimeout(function() {
            sticky2.update();
        },600)
    }
});
//modal search
$('.search-btn').on('click', function(e) {
    e.preventDefault();
    $('.modal-search').css('display', 'flex').fadeIn(300);
    $('.search-form-modal').css('display', 'flex').fadeIn(300);
    $('html, body').addClass('scroll-none');
    setTimeout(function(){
        $('.modal-search input').focus(); 
    },320);
});

$('.modal-search .close-search').on('click', function(e) {
    e.preventDefault();
    $('html, body').removeClass('scroll-none');
    $('.modal-form .box-middle').removeClass('center-content');
    $('.modal-search').fadeOut(300);
});

$('.parent-slider-home').owlCarousel({
    loop: true,
    nav: false,
    dots: true,
    margin: 0,
    items: 1,
    smartSpeed: 2000,
    dotsSpeed: 2000,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
});

$('.play-btn').on('click', function(e) {
    e.preventDefault();
    var link = $(this).attr('data-video');
    $('.modal-video').fadeIn(300).css('display', 'flex');
    $('.modal-video iframe').attr('src', link);
    $('html, body').addClass('scroll-none');
});
$('.modal-video .cap-close').on('click', function() {
    $('.modal-video').fadeOut(0);
    $('.modal-video iframe').attr('src', '');
    $('html, body').removeClass('scroll-none');
});

$('.page-general__iframe-content .parent').on('click', function(e) {
    e.preventDefault();
    var link = $(this).attr('data-url');
    $('.modal-video').fadeIn(300).css('display', 'flex');
    $('.modal-video iframe').attr('src', link);
    $('html, body').addClass('scroll-none');
});

$('.open-nav-mobile').on('click', function(e) {
    e.preventDefault();
    $(this).parent('.parent-link').next().slideToggle(400);
    $('.open-nav-mobile').not(this).parent('.parent-link').next().slideUp(400);
});
$('.close-nav').on('click', function(e) {
    e.preventDefault();
    $(this).parents('.submenu').slideUp(400);
});

$('.sections .faq .title').on('click', function() {
    $(this).next().slideToggle(400);
    $(this).parents('.faq').toggleClass('active');
    if($(this).parents('.faq').hasClass('active')) {
        $(this).find('i').addClass('fa-minus').removeClass('fa-plus');
    } else {
        $(this).find('i').addClass('fa-plus').removeClass('fa-minus');
    }
    $('.sections .faq .title').not(this).next().slideUp(400);
    $('.sections .faq .title').not(this).find('i').addClass('fa-plus');
    $('.sections .faq .title').not(this).parents('.faq').removeClass('active');
});

$('.close-mobile').on('click', function(e) {
    e.preventDefault();
    $('.nav-main').fadeOut(400);
    $('html, body').removeClass('scroll-none');
});

$('.open-mobile').on('click', function(e) {
    e.preventDefault();
    $('.nav-main').css('display','flex').fadeIn(400);
    $('html, body').addClass('scroll-none');
});


let isContactForm = false;
$('.contact-form').on('submit', function(e) {
    e.preventDefault();

    $('.ajax-message').removeClass('alert-danger alert-success');
    $('.ajax-message').hide();
   
    if (isContactForm) return;
    isContactForm = true;

    let $this = $(this);
    let payload = new FormData(this);

    fetch($this.attr('action'), {
        method: $this.attr('method'),
        body: payload
    })
    .then(function (response) {
        return response.json();
    }).then(function (response) {
        if (response.success) {
            $('.ajax-message').addClass('alert-success');
            $this.trigger('reset');
        } else if (!response.success) {
            $('.ajax-message').addClass('alert-danger');
        }

        $('.ajax-message').text(response.data.message).show();
        
        isContactForm = false;
    }).catch(function (err) {
        $('.ajax-message').addClass('alert-danger');
        $('.ajax-message').text('Ha ocurrido un error').show();

        isContactForm = false;

    });

});


$('.contact-form').on('submit', function(e) {
    e.preventDefault();

    $('.ajax-message').removeClass('alert-danger alert-success');
    $('.ajax-message').hide();
   
    if (isContactForm) return;
    isContactForm = true;

    let $this = $(this);
    let payload = new FormData(this);

    fetch($this.attr('action'), {
        method: $this.attr('method'),
        body: payload
    })
    .then(function (response) {
        return response.json();
    }).then(function (response) {
        if (response.success) {
            $('.ajax-message').addClass('alert-success');
            $this.trigger('reset');
        } else if (!response.success) {
            $('.ajax-message').addClass('alert-danger');
        }

        $('.ajax-message').text(response.data.message).show();
        
        isContactForm = false;
    }).catch(function (err) {
        $('.ajax-message').addClass('alert-danger');
        $('.ajax-message').text('Ha ocurrido un error').show();

        isContactForm = false;
    });

});

$('.page-general__news-list').on('click', '.ajax .page-number', function(e) {
    e.preventDefault();

    let _this = $(this);
    if (_this.hasClass('current')) return;

    let parent = _this.closest('.parent-news-list');
    let form = parent.find('.ajax-pagination-form');

    if (form.length == 0) return;
    
    form.find('.current-page-number').val(_this.text());

    loadAjaxNews(form);
});

//Next button
$('.page-general__news-list').on('click', '.ajax .page-item.last', function(e) {
    e.preventDefault();

    let _this = $(this);
    if (_this.hasClass('current')) return;

    let parent = _this.closest('.parent-news-list');
    let form = parent.find('.ajax-pagination-form');

    if (form.length == 0) return;

    let currentPage = parseInt(form.find('.current-page-number').val());
    form.find('.current-page-number').val(currentPage + 1);

    loadAjaxNews(form);
});

//Previous button
$('.page-general__news-list').on('click', '.ajax .page-item.first', function(e) {
    e.preventDefault();

    let _this = $(this);
    if (_this.hasClass('current')) return;

    let parent = _this.closest('.parent-news-list');
    let form = parent.find('.ajax-pagination-form');

    if (form.length == 0) return;

    let currentPage = parseInt(form.find('.current-page-number').val());
    form.find('.current-page-number').val(currentPage - 1);
});

function loadAjaxNews(form) {
    form = $(form);
    let payload = new FormData(form.get(0));

    let container = form.closest('.ajax-news-container');

    fetch(form.attr('action'), {
        method: form.attr('method'),
        body: payload
    })
    .then(function (response) {
        return response.text();
    }).then(function (response) {
        container.html(response);
    }).catch(function (err) {
        container.html('');
    });
}

//Social share
function socialWindow(url) {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
    window.open(url,"NewWindow",params);
}

function setShareLinks() {
    $("a.social-share.facebook").on("click", function(e) {
        e.preventDefault();

        let url = $(this).attr('href');

        url = "https://www.facebook.com/sharer.php?u=" + url;
        socialWindow(url);
    });

    $("a.social-share.twitter").on("click", function(e) {
        e.preventDefault();

        let url = $(this).attr('href');

        url = "https://twitter.com/intent/tweet?url=" + url;
        socialWindow(url);
    });
}

setShareLinks();


$('.copy-href-to-clipboard').on('click', function (e) {
    e.preventDefault();

    var copyText = $(this).attr('href');
    document.addEventListener('copy', function(e) {
       e.clipboardData.setData('text/plain', copyText);
       e.preventDefault();
    }, true);
    var $this = $(this);
    /*$this.append( "<small>¡Copiado!</small>" );

    setTimeout(function() {
        $this.find("small").remove();
    },1500);*/
    document.execCommand('copy');
});

$('.section-tables-filter').on('change', function(e) {
    e.preventDefault();

    let index = this.selectedIndex;

    let parent = $(this).closest('.section-tables');
    let root = parent.closest('.page-general__table-section');

    console.log('#index', index);

    root.find('.section-tables').hide();
    root.find('.section-tables-filter').prop('selectedIndex', index);

    $(root.find('.section-tables').get(index)).show();
});

$('.section-brackets-filter').on('change', function(e) {
    e.preventDefault();

    let index = this.selectedIndex;
    let root = $(this).closest('.page-general__bracket');

    root.find('.tournament-bracket').hide();

    $(root.find('.tournament-bracket').get(index)).show();
});

$(window).scroll(function(){
    console.log($(window).scrollTop());
    if ($(window).scrollTop() >= 65) {
        $('.header .wrapper').addClass('fixed-header');
    }
    else {
        $('.header .wrapper').removeClass('fixed-header');
    }
});

$(window).on('load', function() {
    $('.submenu').addClass('load-submenu')
});